import { useEffect, useState } from 'react';
import { submitTakeItDownReport } from '@genfun/core/api/API';
import { SiteFooter } from '../components/SiteFooter';
import './Legal.css';
import './TakeItDownReport.css';

const SUPPORT_EMAIL = 'support@pornoclaw.com';

function getMediaIdFromUrl() {
    try {
        return new URLSearchParams(window.location.search).get('media_id') || '';
    } catch {
        return '';
    }
}

export function TakeItDownReport({ onNavigate }) {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    const mediaId = getMediaIdFromUrl();
    const hasMediaId = !!mediaId;

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [url, setUrl] = useState('');
    const [description, setDescription] = useState('');
    const [confirmed, setConfirmed] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);

    const targetFilled = hasMediaId ? true : !!url.trim();
    const canSubmit = name.trim() && email.trim() && targetFilled && description.trim() && confirmed && !submitting;

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!canSubmit) return;
        setError(null);
        setSubmitting(true);
        try {
            const [data, status] = await submitTakeItDownReport({
                name: name.trim(),
                email: email.trim(),
                description: description.trim(),
                ...(hasMediaId ? { media_id: mediaId } : { url: url.trim() }),
            });
            if (status >= 200 && status < 300) {
                setSubmitted(true);
            } else if (status === 429) {
                setError('Too many requests. Please try again in a few minutes.');
            } else if (status === 400 && data?.detail) {
                setError(data.detail);
            } else {
                setError('Could not submit the request. Please try again later.');
            }
        } catch (err) {
            setError('Network error. Please check your connection and try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="legalPage">
            <header className="legalNav">
                <span className="legalLogo" onClick={() => onNavigate('video')}>Pornoclaw</span>
                <button className="legalBackBtn" onClick={() => onNavigate('video')}>← Back</button>
            </header>

            <main className="legalBody">
                <span className="legalEyebrow">Report</span>
                <h1 className="legalTitle">Content removal request</h1>
                <div className="legalMeta">Response within 48 hours · {SUPPORT_EMAIL}</div>
                <div className="legalContent">
                    <p className="legalIntro">
                        Under the TAKE IT DOWN Act (TIDA), you may request removal of nonconsensual
                        intimate visual depictions. We process valid requests within 48 hours.
                    </p>

                    {submitted ? (
                        <section className="tidaCard">
                            <h2 className="tidaSuccessTitle">Request received</h2>
                            <p>
                                Thanks — your removal request has been sent to our team. We will review
                                it and respond within 48 hours at the email address you provided.
                            </p>
                        </section>
                    ) : (
                        <form className="tidaForm" onSubmit={onSubmit} noValidate>
                            <label className="tidaField">
                                <span className="tidaLabel">Your full name</span>
                                <input
                                    type="text"
                                    className="tidaInput"
                                    placeholder="Jane Smith"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </label>

                            <label className="tidaField">
                                <span className="tidaLabel">Email address</span>
                                <input
                                    type="email"
                                    className="tidaInput"
                                    placeholder="you@example.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </label>

                            {hasMediaId ? (
                                <div className="tidaField">
                                    <span className="tidaLabel">Reporting gallery item</span>
                                    <div className="tidaPinned">
                                        <span className="tidaPinnedLabel">media_id</span>
                                        <code className="tidaPinnedValue">{mediaId}</code>
                                    </div>
                                    <span className="tidaHelp">
                                        Selected from the gallery — the team will look up this item directly.
                                    </span>
                                </div>
                            ) : (
                                <label className="tidaField">
                                    <span className="tidaLabel">URL(s) of the content to be removed</span>
                                    <textarea
                                        className="tidaInput tidaTextarea"
                                        placeholder="https://pornoclaw.com/..."
                                        value={url}
                                        onChange={(e) => setUrl(e.target.value)}
                                        rows={4}
                                        required
                                    />
                                    <span className="tidaHelp">Paste one URL per line</span>
                                </label>
                            )}

                            <label className="tidaField">
                                <span className="tidaLabel">Describe the content and why you are requesting removal</span>
                                <textarea
                                    className="tidaInput tidaTextarea"
                                    placeholder="Please describe the content and explain why it should be removed..."
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    rows={6}
                                    required
                                />
                            </label>

                            <label className="tidaConfirm">
                                <input
                                    type="checkbox"
                                    checked={confirmed}
                                    onChange={(e) => setConfirmed(e.target.checked)}
                                />
                                <span>
                                    I confirm that the information provided is accurate and that I am the
                                    person depicted or their authorized representative.
                                </span>
                            </label>

                            {error && <div className="tidaError">{error}</div>}

                            <button type="submit" className="tidaSubmit" disabled={!canSubmit}>
                                {submitting ? 'Submitting…' : 'Submit removal request'}
                            </button>
                        </form>
                    )}
                </div>
            </main>

            <SiteFooter onNavigate={onNavigate} />
        </div>
    );
}
